import {
  ACTIVATION_SPRINT_FLAG,
  normalizeActivationSprintVariant,
} from "@/features/activation-sprint/lib/activation-sprint-experiment"
import {
  FIRST_VALUE_PAYWALL_EXPERIMENT_FLAG,
  normalizeFirstValuePaywallVariant,
} from "@/features/credits/lib/first-value-paywall-experiment"

// Retired EXP-002 flag; still parsed so checkouts started from old paywall links keep attribution.
const RETIRED_MESSAGE_LIMIT_FLAG = "exp-002-message-limit-reduction"

export function normalizePaywallExperiment(flag: string | null, variant: string | null) {
  if (
    flag === RETIRED_MESSAGE_LIMIT_FLAG &&
    (variant === "control" || variant === "reduced_limit")
  ) {
    return { flag, variant }
  }

  const firstValueVariant = normalizeFirstValuePaywallVariant(variant ?? undefined)
  if (flag === FIRST_VALUE_PAYWALL_EXPERIMENT_FLAG && firstValueVariant !== "unassigned") {
    return { flag, variant: firstValueVariant }
  }

  const activationSprintVariant = normalizeActivationSprintVariant(variant ?? undefined)
  if (flag === ACTIVATION_SPRINT_FLAG && activationSprintVariant !== "unassigned") {
    return { flag, variant: activationSprintVariant }
  }

  return { flag: null, variant: null }
}
